import { useState } from "react";
import { useAlerts } from "@/hooks";
import { getErrorMessage } from "@/utils/getErrorMessage";
import { IAGAlertManagerDataRow } from "@pulse-ui/types/components/AGTable";
import { useStartAlertMutation, useTestFireAlertMutation } from "../services/alertManagerApi";
import { processBody, mapRowToAlertForm } from "../utils/transformers";

export const useFormModal = () => {
  const { showSuccess, showError } = useAlerts();
  const [open, setOpen] = useState(false);
  const [view, setView] = useState<"start" | "edit" | "duplicate" | null>(null);
  const [selectedSchemaName, setSelectedSchemaName] = useState<
    string | undefined
  >("asset_margin_balance_change_check_config");
  const [preset, setPreset] = useState<any>(undefined);

  const [startAlert] = useStartAlertMutation();
  const [testFireAlert] = useTestFireAlertMutation();

  const openStart = () => {
    setPreset(undefined);
    setView("start");
    setOpen(true);
  };

  const openEdit = (row: IAGAlertManagerDataRow, type?: string) => {
    if (type) setSelectedSchemaName(type);
    setPreset(mapRowToAlertForm(row, "edit"));
    setView("edit");
    setOpen(true);
  };

  const openDuplicate = (row: IAGAlertManagerDataRow, type?: string) => {
    if (type) setSelectedSchemaName(type);
    setPreset(mapRowToAlertForm(row, "duplicate"));
    setView("duplicate");
    setOpen(true);
  };

  const close = () => {
    setOpen(false);
    setPreset(undefined);
    setSelectedSchemaName("asset_margin_balance_change_check_config");
  };

  const handleSubmit = async (data: any) => {
    data["event_type"] = selectedSchemaName;
    const processedData = processBody(data);
    try {
      await startAlert({ payload: processedData }).unwrap();
      showSuccess("Alert started successfully");
      close();
    } catch (err) {
      showError(`Failed to start alert: ${getErrorMessage(err)}`);
    }
  };

  const handleTestFire = async (checkName: string) => {
    if (!checkName) return;
    try {
      await testFireAlert({ check_name: checkName }).unwrap();
      showSuccess(`Successfully test fired ${checkName}`);
    } catch (err) {
      showError(`Error test firing ${checkName}: ${getErrorMessage(err)}`);
    }
  };

  return {
    open,
    view,
    selectedSchemaName,
    setSelectedSchemaName,
    preset,
    setPreset,
    openStart,
    openEdit,
    openDuplicate,
    close,
    handleSubmit,
    handleTestFire,
  };
};
